import { IOAuthProviderConfig } from "../../@types/OAuth";
import { fitbitService } from "../../services/fitbitService";
import { OAuthCallbackPage } from "../OAuthCallback";

const FITBIT_CONFIG: IOAuthProviderConfig = {
  providerName: "Fitbit",
  completeAuthorization: fitbitService.completeAuthorization,
};

export function FitbitCallbackPage() {
  return <OAuthCallbackPage config={FITBIT_CONFIG} />;
}
